import React, { useMemo } from "react";
import { vipPromotion } from "../helper/detailList";
import useVipInfo from "../../../hook/useVipInfo";
import { useSelector } from "react-redux";
import PromotionCard from "./promotionCard";
import { useTranslation } from "react-i18next";

const VipPromotionList = ({ className, customLevel }) => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`vip.${key}`, { ...props });

  const vipConfig = useVipInfo();

  const vipList = useSelector((state) => state.isVipDetail);

  const { nowLevel, nowWash } = vipConfig;

  const level = useMemo(() => {
    return customLevel ? customLevel : nowLevel;
  }, [customLevel, nowLevel]);

  return vipPromotion.map((item) => {
    return vipList[level]?.[item.label] == 0 ||
      !vipList[level]?.[item.label] ? null : (
      <PromotionCard
        className={className}
        icon={item.icon}
        label={i18n(item.label)}
        promotionProps={{
          description: `${vipList[level]?.[item.label]}${item.symbol}`,
        }}
      />
    );
  });
};

export default VipPromotionList;
